import IMG_ICON_1 from '../assets/img/process_icon_1.svg'
import IMG_ICON_2 from '../assets/img/process_icon_2.svg'
import IMG_ICON_3 from '../assets/img/process_icon_3.svg'
import IMG_ICON_4 from '../assets/img/process_icon_4.svg'

import IMG_NUMBER_1 from '../assets/img/process_number_1.webp'
import IMG_NUMBER_2 from '../assets/img/process_number_2.webp'
import IMG_NUMBER_3 from '../assets/img/process_number_3.webp'
import IMG_NUMBER_4 from '../assets/img/process_number_4.webp'

export const listProcessFixture = [
  {
    id: 1,
    icon: IMG_ICON_1,
    number: 'process_step_1',
    title: 'process_title_1',
    des: 'process_des_1'
  },
  {
    id: 2,
    icon: IMG_ICON_2,
    number: 'process_step_2',
    title: 'process_title_2',
    des: 'process_des_2'
  },
  {
    id: 3,
    icon: IMG_ICON_3,
    number: 'process_step_3',
    title: 'process_title_3',
    des: 'process_des_3'
  },
  {
    id: 4,
    icon: IMG_ICON_4,
    number: 'process_step_4',
    title: 'process_title_4',
    des: 'process_des_4'
  }
]
